import React from "react";


import { MdOutlineCancel } from "react-icons/md";

import { Link } from "react-router-dom";

import { logo, darkLogo } from "../../../assets";
import { NavLink } from 'react-router-dom';
import { useStateContext } from "../../../context/ContextProvider";
import { useTranslation } from "react-i18next";
import { AdminLinks } from "../../../constants";
import DButton from "../utils/DButton";





function DashboardSideBar() {
  const { activeMenu,currentColor, setActiveMenu,currentMode, screenSize } = useStateContext()
  const { t} = useTranslation()
  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };
  const handleActiveMenu = () => setActiveMenu(!activeMenu);
  const activeLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg  text-white px-5  text-md m-2';
  const normalLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg px-5 text-md text-gray-700 dark:text-gray-200 hover:text-color-1 dark:hover:text-color-1 hover:bg-light-gray m-2';
 
  return (
    
    <div className=" h-screen  bg-back-primery dark:bg-back-darktertiary sidebar md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
    {activeMenu && (
      <>
        <div className="flex flex-col  w-full mt-5 lg:mt-5 px-4 pt-10 lg:pt-5 justify-center items-center">
          <div className="w-full relative mb-14 justify-start">
          <button
              type="button"
              onClick={() => setActiveMenu(!activeMenu)}
              style={{ color: currentColor }}
              className="text-xl absolute left-4 rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"
            >
              <MdOutlineCancel />
            </button>
          </div>
          <Link to="/" className="items-center">
          <img
              src={currentMode === "Light" ? logo : darkLogo}
              height={60}
              alt="logo"
              className=" h-20"
            />
          </Link>
        </div>
        <div className="mt-10 ">
          {AdminLinks.map((item) => (
            <div key={item.title}>
              <p className="text-gray-400  font-kufi dark:text-gray-400 m-3 mt-4 ">
              {t(item.title)}
              </p>
              {item.links.map((link) => (
                <NavLink
                  to={`/${link.linkSide}`}
                  key={link.name}
                  onClick={handleActiveMenu}
                  style={({ isActive }) => ({
                    backgroundColor: isActive ?"#D97706" : '',
                  })}
                  className={({ isActive }) => (isActive ? activeLink : normalLink)}
                >
                  {link.icon}
                  <span className=" font-kufi ">{t(link.name)}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </div>
        
      </>
    )}
  </div>


  );
}

export default DashboardSideBar;
